import { Record, Map } from "immutable";
import moment from "moment";

const FormsRecord = Record({
  createCategoryTranslation: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      locale: "",
      name: "",
      description: "",
      categoryUID: null
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/categoriesTranslations/forms.js